<!-- template for the modal component -->
<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body">
                        <a class="modal-close lt4-Ex" @click="$emit('close')"></a>
                        <slot name="body">
                            default body
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        beforeCreate() {
            document.body.className = `${document.body.className} modal-open`;
        },
        destroyed() {
            document.body.className = document.body.className.replace('modal-open', '').trim();
        },
    };
</script>
